import { PresentationLanguage, PresentationMarket, PresentationStatus, resolvePageFormat } from './types';

export const COPY = {
  moduleTitle: 'Athena Presentations',
  backToAthena: 'Tillbaka till Athena',
  allPresentations: 'Alla presentationer',
  salesSheets: 'Säljblad',
  allSalesSheets: 'Alla säljblad',
  newSalesSheet: 'Nytt säljblad',
  createSalesSheetTitle: 'Nytt säljblad',
  searchSalesSheets: 'Sök i säljblad',
  noneYetSalesSheets: 'Inga säljblad ännu.',
  noneYetSalesSheetsBody: 'Skapa ett säljblad för utskrift eller PDF.',
  noneInFilterSalesSheets: 'Inga säljblad här.',
  namePlaceholderSalesSheet: 'Till exempel Aviseringsblad augusti',
  confirmDeleteCategorySalesSheet: 'Vill du ta bort kategorin? Säljbladen blir okategoriserade.',
  noSalesSheetTemplates: 'Det finns ingen A4-mall. Skapa en i Mallar först.',
  backToPresentation: 'Tillbaka till presentationen',
  currentViewKindPresentation: '(presentation)',
  currentViewKindTemplate: '(mall)',
  newPresentation: 'Ny presentation',
  createWithAi: 'Skapa med AI',
  createWithAiTitle: 'Skapa presentation med AI',
  createWithAiHelp: 'Skriv vad presentationen ska innehålla. Artikelnummer hämtas från Athena. Mall, typsnitt och färger styrs av Fontana.',
  createWithAiPrompt: 'Beskriv presentationen',
  createWithAiPromptPlaceholder: 'Till exempel: 3 slides om halloumi 97059, med USP:ar, en tabell och nästa steg.',
  createWithAiProducts: 'Produkter',
  createWithAiProductSearch: 'Sök produkt eller artikelnummer',
  createWithAiAttach: 'Bifoga dokument, Excel eller referensbild',
  createWithAiStart: 'Skapa',
  createWithAiWorking: 'Skapar presentationen…',
  createWithAiClarify: 'Behöver ett förtydligande',
  createWithAiContinue: 'Fortsätt',
  createWithAiFailed: 'Kunde inte skapa presentationen.',
  createWithAiCancelled: 'Genereringen avbröts.',
  createWithAiTimeout: 'Genereringen tog för lång tid.',
  createWithAiUnavailable: 'AI-generering är inte tillgänglig just nu.',
  createWithAiWorkbookSheet: 'Blad',
  createWithAiWorkbookFile: 'Excel-fil',
  aiGeneratedBanner: 'Den här presentationen skapades med AI. Granska text och produkter innan du skickar vidare.',
  aiGeneratedRegenerate: 'Regenerera',
  aiGeneratedDelete: 'Ta bort',
  aiGeneratedRegenerateFailed: 'Kunde inte regenerera presentationen.',
  aiGeneratedRegenerateConfirm: 'Befintliga slides ersätts. En återställningspunkt sparas så att du kan gå tillbaka.',
  aiGeneratedDeleteConfirm: 'Vill du radera den AI-genererade presentationen?',
  name: 'Namn',
  open: 'Öppna',
  delete: 'Radera',
  confirmDeletePresentation: 'Vill du radera presentationen? Åtgärden kan inte ångras.',
  renamePresentation: 'Byt namn',
  duplicatePresentation: 'Duplicera',
  duplicatePresentationFailed: 'Kunde inte duplicera presentationen.',
  languageVersions: 'Språkversioner',
  createLanguageVersion: 'Skapa språkversion',
  leaveLanguageGroup: 'Ta bort från språkversioner',
  switchLanguageVersion: 'Växla språkversion',
  languageVersionPairTaken: 'Den här språk- och marknadskombinationen finns redan.',
  languageVersionLocked: 'Språk och marknad kan inte ändras här. Skapa en ny språkversion eller ta bort den här ur gruppen.',
  languageVersionHelp: 'Skapar en kopia som hör ihop med den här presentationen. Versionerna uppdateras inte automatiskt.',
  languageVersionFailed: 'Kunde inte skapa språkversionen.',
  leaveLanguageGroupFailed: 'Kunde inte ta bort presentationen från språkversioner.',
  languageVersionCount: 'språk',
  originReviewPill: 'Originalet ändrat',
  originReviewCardHint: 'Originalet har ändrat text eller bild.',
  libraryUpdateCardHint: 'En sida som följer Sidbiblioteket har en nyare källa.',
  originReviewCopy: 'Kopiera original',
  originReviewInsertPage: 'Lägg in sidan',
  originReviewDismiss: 'Avfärda',
  originReviewOpenOriginal: 'Öppna originalet',
  originReviewOriginal: 'Original',
  originReviewCurrent: 'Den här versionen',
  originReviewFailed: 'Kunde inte kopiera från originalet.',
  originReviewInsertFailed: 'Kunde inte lägga in sidan.',
  originReviewDismissFailed: 'Kunde inte avfärda ändringen.',
  originReviewPage: 'Sida',
  originReviewNewPage: 'Ny sida',
  originReviewKindText: 'text',
  originReviewKindImage: 'bild',
  originReviewKindTable: 'tabell',
  originReviewHelpBox: 'Lägg in originalets innehåll i den här rutan. Avfärda om du vill behålla den här versionen.',
  originReviewHelpImage: 'Lägg in originalets bild i den här rutan, med samma beskärning. Avfärda om du vill behålla den här versionen.',
  originReviewHelpPage: 'Lägger in sidan här. Avfärda om du inte vill ha den nu.',
  originReviewHelpLibraryPage: 'Lägger in sidan här. Den följer Sidbiblioteket, så texten är inte översatt. Avfärda om du inte vill ha den nu. För att skriva engelska eller finska: öppna sidan och välj Gör till egen sida.',
  presentationName: 'Presentationsnamn',
  missingRead: 'Du saknar behörighet att läsa presentationer.',
  noneYet: 'Inga presentationer ännu.',
  noneYetBody: 'Skapa en presentation för nästa säljmöte.',
  createTitle: 'Ny presentation',
  createAction: 'Skapa',
  namePlaceholder: 'Till exempel Q3 sortiment',
  moreActions: 'Fler åtgärder',
  updatedLabel: 'Uppdaterad',
  slideCountLabel: 'sidor',
  confirmDeleteTitle: 'Radera presentationen?',
  workspaceEdit: 'Redigera',
  addSection: 'Lägg till sektion',
  moveSlideUp: 'Flytta upp',
  moveSlideDown: 'Flytta ner',
  selectedCount: 'markerade',
  customColor: 'Egen färg',
  noFill: 'Ingen fyllnad',
  verticalAlign: 'Vertikal justering',
  cornerRadius: 'Hörnradie',
  replaceImage: 'Ersätt bild',
  insertFromFile: 'Från fil',
  insertFromFileFailed: 'Kunde inte infoga bilden från filen.',
  clipboardImageFailed: 'Kunde inte klistra in bilden.',
  dropImageFailed: 'Kunde inte släppa bilden.',
  unsupportedImageType: 'Endast PNG, JPG, WEBP och GIF kan infogas.',
  table: 'Tabell',
  tableHeaderRow: 'Header-rad',
  tableAddRow: 'Lägg till rad',
  tableRemoveRow: 'Ta bort rad',
  tableAddCol: 'Lägg till kolumn',
  tableRemoveCol: 'Ta bort kolumn',
  tablePasteTruncated: 'Tabellen är för stor. Den kapas till 12 kolumner och 40 rader.',
  tablePasteFailed: 'Urklippet är inte en tabell.',
  tableContentLocked: 'Innehållet är låst.',
  tableHeaderFill: 'Headerfärg',
  tableHeaderText: 'Headertext',
  tableGrid: 'Linjefärg',
  tableStrokeWidth: 'Linjetjocklek',
  chart: 'Diagram',
  chartColumn: 'Stapel',
  chartBar: 'Liggande stapel',
  chartBarShort: 'Liggande',
  chartLine: 'Linje',
  chartPie: 'Tårta',
  chartLegend: 'Teckenförklaring',
  chartShowValues: 'Visa värden',
  chartSeries: 'Serie',
  chartCategory: 'Kategori',
  chartAddSeries: 'Lägg till serie',
  chartRemoveSeries: 'Ta bort serie',
  chartAddCategory: 'Lägg till kategori',
  chartRemoveCategory: 'Ta bort kategori',
  chartPasteTruncated: 'Diagrammet är för stort. Det kapas till 12 kategorier och 6 serier.',
  chartPieFirstSeries: 'Tårtan använder första serien. Övriga serier sparas men ritas inte.',
  chartLook: 'Utseende',
  chartData: 'Data',
  chartPasteHint: 'Klistra från Excel när diagrammet är markerat.',
  chartBackground: 'Bakgrund',
  chartBackgroundNone: 'Ingen',
  chartBackgroundWhite: 'Vit',
  chartBackgroundSand: 'Sand',
  settingsChartBackground: 'Bakgrund',
  settingsChartBackgroundHelp: 'Standardbakgrund för nästa diagram som skapas.',
  originReviewKindChart: 'diagram',
  moreCategories: 'Fler',
  shownOfTotal: 'Visar',
  emptySelection: 'Ingen markering.',
  pickBackground: 'Välj en bakgrundsfärg.',
  healthIssues: 'problem',
  loadFailed: 'Kunde inte hämta presentationer.',
  createFailed: 'Kunde inte skapa presentation.',
  deleteFailed: 'Kunde inte radera presentationen.',
  opening: 'Öppnar editorn…',
  simple: 'Enkelt',
  advanced: 'Avancerat',
  saving: 'Sparar…',
  unsaved: 'Osparad',
  saved: 'Sparat nyss',
  saveError: 'Kunde inte spara.',
  undo: 'Ångra (Ctrl/Cmd+Z)',
  redo: 'Gör om (Ctrl/Cmd+Shift+Z)',
  zoomIn: 'Förstora (Ctrl/Cmd++)',
  zoomOut: 'Förminska (Ctrl/Cmd+-)',
  zoomFit: 'Passa in (Ctrl/Cmd+0)',
  health: 'Kvalitetskontroll',
  present: 'Presentera',
  importPptx: 'Importera PPTX',
  importPdf: 'Importera PDF',
  importPdfIntro: 'Importen ersätter alla nuvarande sidor. En ögonblicksbild sparas först så att du kan återställa. Text, bilder och enkla former blir Athena-block på rätt plats. Rubriker blir Kapra Neue och brödtext Akkurat Light. Skuggor får Multiply. Svåra sidor blir en sidbild. Maxstorlek 200 MB.',
  importedPartial: 'Delvis konverterad.',
  importedRaster: 'Importerad som fallback.',
  importPdfChoose: 'Välj .pdf',
  importPdfBusy: 'Tolkar PDF till Athena-format…',
  importColorMismatch: 'Dessa färger stämmer inte överens med ert system',
  importColorMismatchHelp: 'Välj en Fontana-färg för varje färg. Importen skrivs inte förrän alla är matchade. Avbryt lämnar presentationen oförändrad.',
  importColorPick: 'Välj systemfärg',
  importCommit: 'Importera',
  importCommitBusy: 'Skriver sidor…',
  exportPdf: 'Exportera PDF',
  exportPdfFallback: 'PDF klar med bildbackup — den laddas ner till din dator. Klicka Öppna om du inte ser den.',
  slides: 'Sidor',
  addSlide: 'Ny sida',
  deleteSlide: 'Ta bort sida',
  duplicateSlide: 'Duplicera sida',
  hideSlide: 'Dölj sida',
  showSlide: 'Visa sida',
  lockSlide: 'Lås sida',
  unlockSlide: 'Lås upp sida',
  slideActions: 'Sidåtgärder',
  slideHidden: 'Dold',
  slideLocked: 'Sidan är låst',
  allSlidesHidden: 'Alla sidor är dolda. Visa minst en sida för att presentera.',
  resizeStrip: 'Dra för att ändra miniatyrstorlek',
  reorderFailed: 'Kunde inte ändra sidordningen.',
  duplicateFailed: 'Kunde inte duplicera sidan.',
  cannotDeleteLocked: 'Låsta sidor kan inte tas bort. Lås upp sidan först.',
  confirmDeleteSlide: 'Vill du ta bort den här sidan?',
  confirmDeleteSlides: 'Vill du ta bort de här sidorna?',
  deleteSlides: 'Ta bort sidor',
  keepOneSlide: 'Minst en sida måste finnas kvar.',
  notes: 'Anteckningar',
  notesPlaceholder: 'Anteckningar till presentatören',
  overview: 'Översikt',
  grid: 'Rutnät',
  snap: 'Fäst mot rutnät',
  smartGuides: 'Hjälplinjer',
  smartGuidesHint: 'Fäst mot andra objekt',
  history: 'Historik',
  properties: 'Egenskaper',
  layers: 'Lager',
  library: 'Bibliotek',
  presenter: 'Presentationsläge',
  next: 'Nästa',
  lastSlide: 'Sista sidan',
  noNotes: 'Inga anteckningar.',
  blackout: 'Svart skärm (B)',
  pauseTimer: 'Pausa timer (P)',
  resumeTimer: 'Fortsätt timer (P)',
  resetTimer: 'Nollställ timer',
  confirmRestore: 'Vill du återställa den här versionen? Nuvarande innehåll ersätts.',
  restore: 'Återställ',
  close: 'Stäng',
  cancel: 'Avbryt',
  confirm: 'Fortsätt',
  saveSnapshot: 'Spara ögonblicksbild nu',
  confirmLayout: 'Byte av layout ersätter alla objekt på sidan. Vill du fortsätta?',
  importReplaces: 'Importen ersätter alla nuvarande sidor. En ögonblicksbild sparas först så att du kan återställa.',
  confirmImport: 'Jag förstår att alla sidor ersätts.',
  choosePptx: 'Välj .pptx',
  converted: 'konverterade till Athena-format',
  readOnly: 'Skrivskyddad visning',
  product: 'Produkt',
  image: 'Bild',
  text: 'Text',
  shapes: 'Former',
  line: 'Linje',
  place: 'Placera',
  placeAsImage: 'Placera som bild',
  placeAsProduct: 'Placera som produkt',
  replaceMedia: 'Ersätt markerad bild/produkt',
  removeShapeImage: 'Ta bort bild ur formen',
  textInShape: 'Skriv text i formen',
  shadow: 'Skugga',
  multiply: 'Blandningsläge',
  multiplyHelp: 'Gör overlappingen mörkare, som när två tryckfärger läggs på varandra.',
  followLatest: 'Uppdatera automatiskt från Athena',
  followLatestHelp: 'Sliden visar alltid den senaste versionen av filen i Athena. Om originalet byts kan utseendet ändras.',
  keepVersion: 'Behåll versionen som används nu',
  keepVersionHelp: 'Sliden låses till den version som används just nu och ändras inte när filen uppdateras i Athena.',
  ofTotal: 'av',
  sortLabel: 'Sortera',
  sortNewest: 'Nyast – äldsta',
  sortAlpha: 'Bokstavsordning',
  sortArticle: 'Artikelnummer',
  noAssets: 'Inga synliga filer i den här kategorin.',
  assetsFailed: 'Kunde inte hämta Athena-biblioteket.',
  retry: 'Försök igen',
  dragHint: 'Dra en fil till sliden för att placera den. Klicka för att öppna detaljer.',
  bringToFront: 'Lägg överst',
  sendToBack: 'Lägg underst',
  groupObjects: 'Gruppera',
  ungroupObjects: 'Dela upp grupp',
  showInLibrary: 'Visa i biblioteket',
  fieldTextHint: 'Markera och kopiera texten, eller dra handtaget till sliden.',
  allCategories: 'Alla',
  searchAssets: 'Sök titel, filnamn eller tagg',
  unsupportedPlace: 'Filtypen kan inte placeras på en sida.',
  placeFailed: 'Kunde inte förbereda bilden för sliden.',
  goToIssue: 'Gå till felet',
  noBlockers: 'Inga deterministiska blockeringar.',
  blocked: 'Blockerad — presentationen kan inte markeras som klar.',
  healthTitle: 'Kvalitetskontroll',
  blockers: 'Blockeringar',
  warnings: 'Varningar',
  section: 'Sektion',
  up: 'Upp',
  down: 'Ner',
  slideLabel: 'Sida',
  statusDraft: 'Utkast',
  statusReview: 'Granskning',
  statusReady: 'Klar',
  sendToReview: 'Skicka till granskning',
  backToDraft: 'Tillbaka till utkast',
  markReady: 'Markera som klar',
  backToReview: 'Tillbaka till granskning',
  statusChangeFailed: 'Kunde inte ändra status.',
  filterAll: 'Alla',
  searchPresentations: 'Sök i presentationer',
  uncategorized: 'Okategoriserade',
  deckCategory: 'Kategori',
  noDeckCategory: 'Ingen kategori',
  newCategory: 'Ny kategori',
  newSubcategory: 'Ny underkategori',
  renameCategory: 'Byt namn',
  deleteCategory: 'Ta bort kategori',
  categoryNamePlaceholder: 'Kategorinamn',
  confirmDeleteCategory: 'Vill du ta bort kategorin? Presentationerna blir okategoriserade.',
  categoryHasChildren: 'Ta bort underkategorierna först.',
  moveToCategory: 'Flytta till kategori',
  noneInFilter: 'Inga presentationer här.',
  noneInFilterBody: 'Prova en annan kategori eller sök på andra ord.',
  mediaApplied: 'uppdaterades från Athena',
  mediaAvailable: 'pin-versioner har nyare original i Athena.',
  mediaAvailableOne: '1 pin har nyare original i Athena.',
  showBlock: 'Visa block',
  updateFromAthena: 'Uppdatera från Athena',
  keepPin: 'Behåll pin',
  linkedTitle: 'Titel',
  linkedArticle: 'Artikelnummer',
  linkedDirect: 'Direct',
  linkedLocal: 'Local',
  linkedDirectHelp: 'Texten följer artikeln i Athena. Den skrivs inte tillbaka.',
  linkedLocalHelp: 'Egen text på sliden. Athena ändras inte.',
  boundFieldLinked: 'Kopplad',
  boundFieldMakeLocal: 'Gör till egen text',
  boundFieldPromptTitle: 'Gör till egen text?',
  boundFieldPromptBody: 'Den här rutan är kopplad till en produkt i Athena. Informationen hämtas och uppdateras automatiskt.\n\nObs! Om du ändrar texten bryts kopplingen. Framtida ändringar av produktinformationen i Athena kommer då inte att uppdateras i den här rutan.',
  boundFieldPromptConfirm: 'Ja, gör till egen text',
  icon: 'Ikon',
  comments: 'Kommentarer',
  commentPlaceholder: 'Skriv en kommentar till sidan',
  commentEmpty: 'Inga kommentarer på den här sidan.',
  resolveComment: 'Lös',
  commentResolved: 'Löst',
  globalComponents: 'Komponenter',
  saveGlobal: 'Spara som global komponent',
  placeGlobal: 'Placera',
  detachGlobal: 'Lossa från original',
  detachedGlobal: 'Lossa från originalet. Ändringar i biblioteket synkas inte längre.',
  aiRewrite: 'Skriv om',
  aiTranslate: 'Översätt',
  aiGrammar: 'Grammatik',
  aiChat: 'AI',
  aiTabBox: 'Textruta',
  aiTabChat: 'Chatt',
  aiChatPlaceholder: 'Till exempel: skriv om som copywriter, kortare och säljande.',
  aiChatHelp: 'Skriv hur den markerade textrutan ska ändras. Texten byts ut och anpassas efter rutans storlek.',
  aiChatThreadHelp: 'Fråga, be om copy eller få förslag. Det här är en chatt — den byter inte ut en ruta förrän du väljer Infoga.',
  aiChatEmpty: 'Inga meddelanden än. Fråga till exempel hur en rubrik kan skrivas, eller be om en text om en produkt.',
  aiChatInput: 'Skriv en fråga eller be om en text…',
  aiChatSend: 'Skicka',
  aiChatInsert: 'Infoga i rutan',
  aiChatClear: 'Rensa chatten',
  aiChatInserted: 'Texten är infogad i rutan.',
  aiNeedsTextSelection: 'Markera en textruta först.',
  aiNoResult: 'AI kunde inte ändra texten. Försök igen.',
  aiNoChange: 'AI lämnade texten oförändrad.',
  aiUnavailable: 'AI är avstängd eller inte konfigurerad.',
  aiRewriteBusy: 'Skriver om…',
  aiGrammarBusy: 'Rättar grammatik…',
  aiRewriteDone: 'Texten är omskriven.',
  aiGrammarDone: 'Grammatiken är uppdaterad.',
  aiFix: 'Fixa med AI',
  aiSuggestions: 'AI-förslag',
  fitSlot: 'Passa i slot',
  fitSlotHelp: 'Flyttar det markerade objektet till en namngiven yta på samma sida, till exempel produktrutan. Bara vissa layouter har slots.',
  fitSlotUnavailable: 'Den här sidan har ingen slot, eller det markerade objektet är låst i läge eller storlek.',
  fitImageInFrame: 'Visa hela bilden',
  adaptStyles: 'Rätta till typsnitt och färger',
  adaptStylesHelp: 'Byter olåsta typsnitt och färger som inte är Fontanas. Ändrar inte sidans layout.',
  adaptStylesUnavailable: 'Inget olåst objekt har typsnitt eller färg utanför varumärket.',
  templates: 'Mallar',
  templatesHelp: 'Rita sidtyper och bind rutor till Athena-fält. Det här är mallar, inte mapparna på startsidan.',
  templatesEmpty: 'Inga mallar ännu.',
  newTemplate: 'Ny mall',
  templateName: 'Mallnamn',
  templateNamePlaceholder: 'Till exempel Konferens',
  renameTemplate: 'Byt namn på mall',
  archiveTemplate: 'Arkivera mall',
  restoreTemplate: 'Återställ mall',
  archivedTemplate: 'Arkiverad',
  confirmArchiveTemplate: 'Arkivera mallen? Befintliga presentationer som redan använder den går fortfarande att öppna.',
  openTemplate: 'Redigera mall',
  editTemplates: 'Redigera mallar',
  templateMode: 'Malläge',
  templateModeBanner: 'Du redigerar mallen, inte en presentation.',
  templateModeHelp: 'Ändringar påverkar inte befintliga presentationer förrän någon väljer Uppdatera från mall.',
  newLayout: 'Ny layout',
  layoutName: 'Layoutnamn',
  renameLayout: 'Byt namn på layout',
  deleteLayout: 'Ta bort layout',
  confirmDeleteLayouts: 'Vill du ta bort de här layouterna?',
  keepOneLayout: 'Mallen måste ha minst en layout.',
  fieldBinding: 'Fältbindning',
  fieldBindingNone: 'Ingen bindning',
  fieldBindingProduct: 'Produkter',
  fieldBindingWine: 'Vin',
  fieldBindingChooseProduct: 'Välj produktfält',
  fieldBindingChooseWine: 'Välj vinfält',
  fieldBindingHelp: 'När en säljare släpper en produkt fylls den här rutan från Athena.',
  productBindingHelp: 'Den här ytan är produkten. En drop byter bild och fyller bundna textrutor.',
  linkedMeasure: 'Mått',
  templateLabel: 'Mall',
  templateVsCategory: 'Mall (sidlayout). Kategori är mappen på startsidan.',
  changeTemplate: 'Byt mall',
  changeTemplateHelp: 'Sidor vars layout finns i den nya mallen kan uppdateras. Övriga sidor lämnas.',
  changeTemplateNoMatch: 'Ingen sida har samma layout-id i den nya mallen. Befintliga sidor lämnas orörda.',
  updateFromTemplate: 'Uppdatera från mall',
  updateFromTemplateHelp: 'Tar ny geometri och stil från mallen. Produkten och Local-text behålls.',
  updateFromTemplateDone: 'Sidan är uppdaterad från mallen.',
  updateFromTemplateMissing: 'Den här sidans layout finns inte i den aktuella mallen.',
  chooseLayout: 'Välj sidtyp',
  templatePickerHelp: 'Klicka på en mall för att lägga till en sida. Har mallen flera sidtyper väljer du sidtyp i nästa steg.',
  searchTemplates: 'Sök mall',
  searchLayouts: 'Sök sidtyp',
  noTemplateMatches: 'Inga mallar matchar sökningen.',
  noLayoutMatches: 'Inga sidtyper matchar sökningen.',
  pageTypeHelp: 'Välj vilken sidtyp som ska läggas till i presentationen.',
  allTemplates: 'Alla mallar',
  editTemplate: 'Redigera',
  duplicateTemplate: 'Duplicera',
  deleteTemplate: 'Ta bort',
  templateCardMenu: 'Åtgärder för mallen',
  pageTypeCountLabel: 'sidtyper',
  pageTypeCountOne: 'sidtyp',
  emptyAviseringHelp: 'Aviseringsblad är en tom mall tills du ritar den i Malläge.',
  pageFormat: 'Sidformat',
  pageFormatWidescreen: '16:9',
  pageFormatA4: 'A4',
  pageFormatHelp: '16:9 för skärm. A4 för säljblad som ska skrivas ut.',
  pageFormatMismatch: 'Mallen har ett annat sidformat. Byt bara till en mall med samma format.',
  pageFormatAddSlideMismatch: 'Sidtypen tillhör en mall med ett annat sidformat.',
  pptxA4Blocked: 'PowerPoint-import fungerar bara i 16:9-presentationer.',
  slideLibrary: 'Sidbibliotek',
  slideLibraryHelp: 'Publicera färdiga sidor som säljaren kan lägga in i en presentation. Sidor som följer biblioteket uppdateras när originalet ändras.',
  libraryCardMenu: 'Åtgärder för sidan',
  slideLibraryEmpty: 'Inga bibliotekssidor ännu.',
  archivedLibraryEmpty: 'Inga arkiverade sidor.',
  libraryActiveTab: 'Aktiva',
  libraryArchivedTab: 'Arkiverade',
  newLibrarySlide: 'Ny bibliotekssida',
  librarySlideName: 'Sidnamn',
  librarySlideNamePlaceholder: 'Till exempel Prislista',
  renameLibrarySlide: 'Byt namn på sida',
  archiveLibrarySlide: 'Arkivera sida',
  restoreLibrarySlide: 'Återställ sida',
  archivedLibrarySlide: 'Arkiverad',
  confirmArchiveLibrarySlide: 'Arkivera sidan? Befintliga presentationer behåller innehållet, men sidor som följde den blir egna sidor.',
  openLibrarySlide: 'Redigera sida',
  libraryMode: 'Sidbibliotek',
  libraryModeBanner: 'Du redigerar sidbiblioteket.',
  libraryModeHelp: 'Ändringar syns i presentationer där sidan fortfarande följer Sidbiblioteket.',
  currentViewKindLibrary: '(sidbibliotek)',
  libraryPickerHelp: 'Klicka för att lägga in sidan. Du väljer om den ska följa Sidbiblioteket eller bli en egen sida.',
  saveToLibrary: 'Spara i Sidbibliotek',
  savedToLibrary: 'Sidan finns nu i Sidbiblioteket.',
  addAsTemplate: 'Lägg till som mall',
  addAsTemplateTitle: 'Lägg till som mall',
  addAsTemplateHelp: 'Sidan blir en ny mallsida i valt kit. Du kan justera den efteråt.',
  addAsTemplateKit: 'Kit',
  addAsTemplateName: 'Namn på mallsida',
  addAsTemplateSubmit: 'Lägg till',
  addAsTemplateSubmitOpen: 'Lägg till och öppna',
  addAsTemplateDone: 'Mallsidan finns nu i kitet.',
  addAsTemplateNoKits: 'Inget kit med samma sidformat.',
  addAsTemplatePageFormat: 'Kitet har ett annat sidformat. Välj ett kit med samma format.',
  duplicateLayout: 'Duplicera',
  copyLayoutToKit: 'Kopiera till annat kit',
  moveLayoutToKit: 'Flytta till annat kit',
  copyLayoutToKitTitle: 'Kopiera till annat kit',
  moveLayoutToKitTitle: 'Flytta till annat kit',
  copyLayoutSubmit: 'Kopiera',
  moveLayoutSubmit: 'Flytta',
  copyLayoutDone: 'Mallsidan kopierades.',
  moveLayoutDone: 'Mallsidan flyttades.',
  layoutCardMenu: 'Åtgärder för mallsidan',
  libraryDropHelp: 'Dra en sida hit från vänsterspalten för att spara den i Sidbiblioteket.',
  searchLibrarySlides: 'Sök bibliotekssida',
  noLibrarySlideMatches: 'Inga bibliotekssidor matchar sökningen.',
  libraryPickerFormatEmpty: 'Inga bibliotekssidor med samma sidformat.',
  libraryLinkedBanner: 'Den här sidan följer Sidbiblioteket',
  libraryLinkedHelp: 'Innehållet kommer därifrån. Anteckningar, dölj och ordning är dina. För att översätta: Gör till egen sida.',
  libraryDetach: 'Gör till egen sida',
  libraryDetached: 'Sidan är nu en egen sida. Den uppdateras inte längre från Sidbiblioteket.',
  libraryFollowBadge: 'Sidbibliotek',
  pageKindProduct: 'Produkt',
  pageKindLibraryHint: 'Den här sidan följer Sidbiblioteket.',
  pageKindProductHint: 'Sidan har rutor kopplade till produktdata i Athena.',
  pageKindInfo: 'Mer information',
  pageKindLibraryInfo: 'Innehållet kommer från Sidbiblioteket och skrivs om när du öppnar presentationen. Du kan inte översätta eller ändra text och bild här. För att redigera: Gör till egen sida. Då följer den inte längre biblioteket.',
  pageKindProductInfo: 'Namn, pris, bild och liknande fylls från produkten i Athena. Ändrar du en kopplad ruta och öppnar om kan texten hoppa tillbaka. Det ska den göra. Kopplade rutor gäller när sidan är din egen. Vill du skriva egen text i en ruta: markera rutan och välj Local. Vill du byta innehåll: släpp en annan produkt på sidan.',
  productLinkedBanner: 'Den här sidan har koppling till produktdata',
  productLinkedHelp: 'Vissa rutor fylls från produkten i Athena och kan hoppa tillbaka när du öppnar om.',
  libraryInsertTitle: 'Hur vill du lägga in sidan?',
  libraryInsertFollow: 'Följ Sidbiblioteket',
  libraryInsertFollowHelp: 'Rekommenderas när samma sida ska hållas lika överallt. Ändringar i Sidbiblioteket kommer in här automatiskt.',
  libraryInsertOwn: 'Gör en egen sida',
  libraryInsertOwnHelp: 'En kopia bara i den här presentationen. Du kan ändra den utan att påverka andra.',
  libraryInsertFollowDone: 'Sidan följer Sidbiblioteket.',
  libraryInsertOwnDone: 'Sidan är en egen kopia i den här presentationen.',
  libraryUpdateTitle: 'Sidbiblioteket har uppdaterat sidor',
  libraryUpdateHelp: 'Klicka på en sida för att gå dit.',
  libraryUpdateContent: 'Innehållet uppdaterades från Sidbiblioteket.',
  libraryUpdateBackground: 'Bakgrunden uppdaterades från Sidbiblioteket.',
  libraryUpdateContentAndBackground: 'Innehåll och bakgrund uppdaterades från Sidbiblioteket.',
  libraryUpdateSourceMissing: 'Källan saknas. Sidan är nu en egen sida.',
  librarySourceMissing: 'Källan saknas',
  librarySourceMissingHelp: 'Bibliotekssidan är arkiverad eller borttagen. Innehållet är kvar och sidan är nu en egen sida.',
  libraryGroup: 'Grupp',
  libraryGroupAll: 'Alla',
  libraryGroupProduct: 'Produkt',
  libraryGroupPrice: 'Pris',
  libraryGroupAgenda: 'Agenda',
  libraryGroupOther: 'Övrigt',
  libraryLabels: 'Etiketter',
  libraryLabelName: 'Etikettnamn',
  libraryLabelNamePlaceholder: 'Till exempel Kampanj',
  manageLibraryLabels: 'Hantera etiketter',
  newLibraryLabel: 'Ny etikett',
  renameLibraryLabel: 'Byt namn',
  deleteLibraryLabel: 'Ta bort etikett',
  confirmDeleteLibraryLabel: 'Ta bort etiketten? Den försvinner från sidorna, men sidorna finns kvar.',
  assignLibraryLabels: 'Välj etiketter',
  noLibraryLabels: 'Inga etiketter ännu.',
  libraryPageFormatMismatch: 'Bibliotekssidan har ett annat sidformat.',
  settings: 'Inställningar',
  settingsHelp: 'Styr palett, AI-prompter och standarder för presentationer och säljblad. Ändringar gäller nya rutor och nästa AI-anrop.',
  settingsColors: 'Färger',
  settingsPrompts: 'AI-prompter',
  settingsTextTable: 'Text och tabell',
  settingsFonts: 'Typsnitt',
  settingsHealth: 'Kvalitet',
  settingsFields: 'Produktfält',
  settingsLanguages: 'Språk och marknad',
  settingsSave: 'Spara',
  settingsSaved: 'Inställningarna är sparade.',
  settingsSavedStatus: 'Sparad',
  settingsDirty: 'Osparade ändringar',
  settingsUnsavedShort: 'Osparad',
  settingsFailed: 'Kunde inte spara inställningarna.',
  settingsReset: 'Återställ till standard',
  settingsSection: 'Sektion',
  settingsMoreInfo: 'Mer information',
  settingsLeaveTitle: 'Osparade ändringar',
  settingsLeaveBody: 'Du har ändringar som inte är sparade. Vill du lämna utan att spara?',
  settingsLeaveConfirm: 'Lämna utan att spara',
  settingsLeaveStay: 'Stanna kvar',
  settingsResetTitle: 'Återställ till standard?',
  settingsResetBody: 'Sätter den här sektionen till kodens standardvärden. Du måste spara för att ändringen ska gälla.',
  settingsResetConfirm: 'Återställ',
  settingsColorsNav: 'Palett och standardfärger',
  settingsPromptsNav: 'Claude-texter',
  settingsTextTableNav: 'Nya rutor och tabeller',
  settingsFontsNav: 'Namn och synlighet',
  settingsHealthNav: 'Regler och trösklar',
  settingsFieldsNav: 'Etiketter och alias',
  settingsLanguagesNav: 'Synliga språk',
  settingsColorsIntro: 'Välj vilka färger som syns i editorn och vilka som används för ny text och nya former.',
  settingsColorsConsequence: 'Gäller nya objekt. Redan ritade sidor byter inte färg av sig själva.',
  settingsPromptsIntro: 'De här texterna går till Claude, inte till knapparna i editorn.',
  settingsPromptsConsequence: 'Ändringar gäller nästa AI-anrop.',
  settingsTextTableIntro: 'Bestäm hur nya textrutor och tabeller skapas, och hur importerad text ska se ut.',
  settingsTextTableConsequence: 'Befintliga rutor och tabeller på sidorna ändras inte.',
  settingsFontsIntro: 'Byt visningsnamn eller dölj en typsnittsvariant i listan.',
  settingsFontsConsequence: 'Objekt som redan använder typsnittet behåller det.',
  settingsHealthIntro: 'Slå av regler som inte ska rapporteras, och justera hur full en ruta ska vara.',
  settingsHealthConsequence: 'Gäller nästa kvalitetskontroll och nästa Skriv om.',
  settingsFieldsIntro: 'Koppla logiska produktfält till rätt nycklar i Athena.',
  settingsFieldsConsequence: 'Fel alias ger tomma rutor när en produkt släpps på sliden.',
  settingsLanguagesIntro: 'Välj vilka språk och marknader som syns när någon skapar en ny version.',
  settingsLanguagesConsequence: 'Befintliga presentationer och säljblad öppnas som förut, även om språket är dolt.',
  settingsLanguagesCard: 'Språk',
  settingsFontFamily: 'Typsnitt',
  settingsDefaultsCard: 'Standardfärger',
  settingsPaletteCard: 'Palett',
  settingsAllowCustomHex: 'Tillåt egen färg',
  settingsAllowCustomHexHelp: 'Visar valet Egen färg i editorn så säljaren kan skriva en hexkod utanför paletten.',
  settingsDefaultTextColor: 'Standardfärg för ny text',
  settingsDefaultTextColorHelp: 'Används när någon skapar en ny textruta.',
  settingsDefaultShapeColor: 'Standardfärg för ny form',
  settingsDefaultShapeColorHelp: 'Används när någon skapar en ny form.',
  settingsAddColor: 'Lägg till färg',
  settingsColorName: 'Namn',
  settingsColorHex: 'Hex',
  settingsColorHexHelp: 'Sex tecken, till exempel #1B3967.',
  settingsColorGroup: 'Grupp',
  settingsColorPreview: 'Förhandsvisning',
  settingsColorPreviewText: 'Förhandsvisning av ny textfärg',
  settingsColorPreviewShape: 'Ny form',
  settingsColorPreviewSample: 'Aa',
  settingsLastVisibleColor: 'Minst en färg måste vara synlig.',
  settingsHidden: 'Dold',
  settingsNewTextCard: 'Ny textruta',
  settingsNewTextPlaceholder: 'Ny text',
  settingsNewTextPlaceholderHelp: 'Texten som syns i en nyskapad textruta. Befintliga rutor ändras inte.',
  settingsNewTextStyle: 'Stil för ny textruta',
  settingsNewTextStyleHelp: 'Vilken av de fyra editorstilarna den nya rutan skapas som.',
  settingsEditorStylesCard: 'Textstilar i editorn',
  settingsEditorStylesHelp: 'Dessa stilar syns i editorns stilväljare. Befintliga rutor behåller sin nuvarande storlek.',
  settingsImportCard: 'Importstilar',
  settingsImportHelp: 'Används när PowerPoint eller en produkt släpps in. De styr inte editorns Rubrik 96 / Brödtext 32.',
  settingsImportHeading: 'Import rubrik',
  settingsImportBody: 'Import bröd',
  settingsTableCard: 'Ny tabell',
  settingsTableHelp: 'Gäller nästa tabell som skapas. Befintliga tabeller ändras inte.',
  settingsTableCols: 'Kolumner',
  settingsTableColsHelp: 'Antal kolumner i en ny tabell. Tillåtet 1–12.',
  settingsTableRows: 'Rader',
  settingsTableRowsHelp: 'Totalt antal rader inklusive rubrikraden. Tillåtet 1–40.',
  settingsTableFont: 'Textstorlek i tabellen',
  settingsTableFontHelp: 'Standardstorlek för celltext. Tillåtet 8–72.',
  settingsTableHeaderColor: 'Header',
  settingsTableHeaderHelp: 'Bakgrund på översta rubrikraden.',
  settingsTableGridColor: 'Rutnät',
  settingsTableGridHelp: 'Färg på linjerna mellan cellerna.',
  settingsTableZebraColor: 'Zebra',
  settingsTableZebraHelp: 'Bakgrund på varannan datarad.',
  settingsTablePreview: 'Förhandsvisning',
  settingsTablePreviewHeader: 'Rubrik',
  settingsTablePreviewCell: 'Cell',
  settingsChartCard: 'Nytt diagram',
  settingsChartHelp: 'Gäller nästa diagram som skapas. Befintliga diagram ändras inte.',
  settingsChartKind: 'Typ',
  settingsChartKindHelp: 'Standardtyp för ett nytt diagram.',
  settingsChartFont: 'Textstorlek i diagrammet',
  settingsChartFontHelp: 'Standardstorlek för axlar och etiketter. Tillåtet 8–72.',
  settingsChartGridColor: 'Rutnät',
  settingsChartGridHelp: 'Färg på hjälplinjerna i diagrammet.',
  settingsChartSeriesColor: 'Serie',
  settingsChartSeriesHelp: 'Palettfärger i ordning för nya serier.',
  settingsChartLegend: 'Teckenförklaring',
  settingsChartValues: 'Visa värden',
  settingsChartPreview: 'Förhandsvisning av diagram',
  settingsHealthChartEmpty: 'Diagram utan värden',
  settingsHealthChartEmptyHelp: 'Rapporterar när diagrammet saknar värden att rita. Blockerar inte Ready.',
  settingsUnitPt: 'pt',
  settingsFieldAliasesHelp: 'Alias måste matcha fältnycklar i Athena. Fel alias ger tomma rutor när produkten släpps.',
  settingsFieldId: 'Tekniskt id',
  settingsFieldLabel: 'Visningsetikett',
  settingsFieldAliasHint: 'Skriv ett alias och tryck Enter. Minst ett alias krävs.',
  settingsFieldAliasExample: 'Exempel: produktnamn, artikelnummer, volym_vin_id.',
  settingsLastAlias: 'Varje fält behöver minst ett alias.',
  settingsHealthRulesCard: 'Regler',
  settingsHealthRulesHelp: 'Avstängd regel rapporteras inte i kvalitetskontrollen.',
  settingsHealthThresholdsCard: 'Trösklar',
  settingsHealthOverflow: 'Overflow',
  settingsHealthOverflowHelp: 'Text räknas som för stor när den fyller mer än den här andelen av rutan.',
  settingsHealthUnderfill: 'Underfyllnad',
  settingsHealthUnderfillHelp: 'Text räknas som för kort när den fyller mindre än den här andelen av rutan.',
  settingsRewriteFit: 'Skriv om-band',
  settingsRewriteFitHelp: 'Minsta andel av rutans teckenbudget som Skriv om ska fylla.',
  settingsPercent: '%',
  settingsVisible: 'Synlig',
  settingsFontVisible: 'Synlig i typsnittslistan',
  settingsFontLabel: 'Visningsnamn',
  settingsFontSample: 'Aa Åäö 123',
  settingsLanguageCode: 'Kod',
  settingsLanguageLabel: 'Visningsnamn',
  settingsLastVisibleLocale: 'Minst ett val måste vara synligt.',
  settingsLocaleHiddenHelp: 'Dolda alternativ visas inte när någon skapar en ny språkversion.',
  settingsPromptRewriteCard: 'Skriv om',
  settingsPromptOtherCard: 'Övriga AI-funktioner',
  settingsPromptTechCard: 'Teknisk formatering',
  settingsPromptHtmlDiff: 'slide-HTML är stycken, listor och fet/kursiv. Markdown som **fet** fungerar inte i rutan.',
  settingsPromptRefineKeep: 'Låt {n}, {min}, {max} och {lines} stå kvar. Athena fyller i siffrorna.',
  settingsPromptsHelp: 'De här texterna går till Claude, inte till knapparna i editorn. Ändringar gäller nästa AI-anrop.',
  settingsPromptRewriteSystem: 'Skriv om, system',
  settingsPromptRewriteSystemHelp: 'Gäller knappen Skriv om. Bestämmer hur AI:n ska skriva om texten, till exempel ton och vad som ska behållas.',
  settingsPromptRewriteUser: 'Skriv om, användartext',
  settingsPromptRewriteUserHelp: 'Den fasta uppmaningen som skickas med rutan när säljaren inte skriver en egen instruktion i AI-panelen.',
  settingsPromptGrammar: 'Grammatik',
  settingsPromptGrammarHelp: 'Gäller knappen Grammatik. Rätta stavning och språk utan att byta budskap.',
  settingsPromptTranslate: 'Översätt',
  settingsPromptTranslateHelp: 'Gäller knappen Översätt. Målspråket väljs i editorn. Här styr du hur översättningen ska göras.',
  settingsPromptChat: 'Chatt',
  settingsPromptChatHelp: 'Gäller fliken Chatt. Sätter rollen för fria frågor, till exempel språk och att inte skicka bilder.',
  settingsPromptHtml: 'HTML-regel',
  settingsPromptHtmlHelp: 'Ingen egen knapp. Klistras på Skriv om, Grammatik och Översätt så svaret stannar som slide-HTML (stycken, listor, fet/kursiv) och inte markdown.',
  settingsPromptRefine: 'Andra passet (Skriv om-band)',
  settingsPromptRefineHelp: 'Ett extra Skriv om-varv om första svaret inte fyller rutan. Låt {n}, {min}, {max} och {lines} stå kvar — Athena fyller i siffrorna.',
  settingsHealthTextOverflow: 'Text ryms inte',
  settingsHealthTextOverflowHelp: 'Rapporterar när texten inte får plats i rutan.',
  settingsHealthTableOverflow: 'Tabell ryms inte',
  settingsHealthTableOverflowHelp: 'Rapporterar när tabellen inte får plats i rutan.',
  settingsHealthSafeArea: 'Utanför säker yta',
  settingsHealthSafeAreaHelp: 'Rapporterar objekt som ligger utanför sidans säkra yta.',
  settingsHealthLockedFont: 'Låst typsnitt',
  settingsHealthLockedFontHelp: 'Rapporterar när ett låst objekt använder fel typsnitt.',
  settingsHealthFontUnapproved: 'Otillåtet typsnitt',
  settingsHealthFontUnapprovedHelp: 'Rapporterar typsnitt som inte ingår i de tillåtna.',
  settingsHealthLockedColor: 'Låst färg',
  settingsHealthLockedColorHelp: 'Rapporterar när ett låst objekt använder en färg utanför paletten.',
  settingsHealthMissingMedia: 'Saknad media',
  settingsHealthMissingMediaHelp: 'Rapporterar bilder eller produkter utan fil.',
  settingsHealthAssetMissing: 'Tillgång saknas',
  settingsHealthAssetMissingHelp: 'Rapporterar när den kopplade tillgången inte finns.',
  settingsHealthAssetAccess: 'Tillgångsbehörighet',
  settingsHealthAssetAccessHelp: 'Rapporterar när säljaren saknar rätt att se tillgången.',
  settingsMoveUp: 'Flytta upp',
  settingsMoveDown: 'Flytta ner',
  settingsColorGroupPrimary: 'Primär',
  settingsColorGroupComplement: 'Komplement',
  settingsColorGroupAccent: 'Accent',
  settingsFontSize: 'Storlek',
  settingsFontWeight: 'Vikt',
  settingsUppercase: 'Versaler',
  settingsLineHeight: 'Radavstånd',
  settingsAliases: 'Alias',
  settingsMarkets: 'Marknader',
  aiTranslateBusy: 'Översätter…',
  aiTranslateDone: 'Texten är översatt.',
  aiTranslateTo: 'Översätt till',
} as const;

export function settingsSaveLabel(sectionLabel: string): string {
  return `${COPY.settingsSave} ${sectionLabel}`;
}

export function marketLabel(market: PresentationMarket, override?: string): string {
  if (override?.trim()) return override.trim();
  if (market === 'FI') return 'Finland';
  if (market === 'INT') return 'Internationellt';
  return 'Sverige';
}

export function languageLabel(language: PresentationLanguage, override?: string): string {
  if (override?.trim()) return override.trim();
  if (language === 'fi') return 'Finska';
  if (language === 'en') return 'Engelska';
  return 'Svenska';
}

export function statusLabel(status: PresentationStatus): string {
  if (status === 'review') return COPY.statusReview;
  if (status === 'ready') return COPY.statusReady;
  return COPY.statusDraft;
}

export function slideCountText(count: number): string {
  return `${count} ${count === 1 ? 'sida' : COPY.slideCountLabel}`;
}

export function pageTypeCountText(count: number): string {
  return `${count} ${count === 1 ? COPY.pageTypeCountOne : COPY.pageTypeCountLabel}`;
}

export function pageFormatLabel(format?: string | null): string {
  return resolvePageFormat(format) === 'a4_portrait' ? COPY.pageFormatA4 : COPY.pageFormatWidescreen;
}

export function mediaAvailableText(count: number): string {
  return count === 1 ? COPY.mediaAvailableOne : `${count} ${COPY.mediaAvailable}`;
}

export function originReviewPageCount(items: Array<{ slideId: string; kind?: string }>): number {
  return new Set(items.filter((item) => item.kind !== 'page').map((item) => item.slideId)).size;
}

export function originReviewNewPageCount(items: Array<{ kind?: string }>): number {
  return items.filter((item) => item.kind === 'page').length;
}

export function originReviewBannerText(
  items: Array<{ slideId: string; kind?: string }>,
  language: PresentationLanguage,
): string {
  const changed = originReviewPageCount(items);
  const added = originReviewNewPageCount(items);
  const parts: string[] = [];
  if (changed) {
    const pages = changed === 1 ? '1 sida har' : `${changed} sidor har`;
    parts.push(`${pages} ändrats i originalet (${languageLabel(language).toLowerCase()}).`);
  }
  if (added === 1) parts.push('Originalet har 1 ny sida.');
  if (added > 1) parts.push(`Originalet har ${added} nya sidor.`);
  return parts.join(' ');
}

export function originReviewItemLabel(item: { kind?: string; pageIndex: number }): string {
  if (item.kind === 'page') return COPY.originReviewNewPage;
  const kind = item.kind === 'image'
    ? COPY.originReviewKindImage
    : item.kind === 'table'
      ? COPY.originReviewKindTable
      : item.kind === 'chart'
        ? COPY.originReviewKindChart
        : COPY.originReviewKindText;
  return `${COPY.originReviewPage} ${item.pageIndex + 1} · ${kind}`;
}

export function originReviewHelpText(kind?: string, libraryFollow?: boolean): string {
  if (kind === 'page' && libraryFollow) return COPY.originReviewHelpLibraryPage;
  if (kind === 'page') return COPY.originReviewHelpPage;
  if (kind === 'image') return COPY.originReviewHelpImage;
  return COPY.originReviewHelpBox;
}

export function confirmDeleteSlidesText(count: number, templateMode?: boolean): string {
  if (count <= 1) return templateMode ? COPY.deleteLayout : COPY.confirmDeleteSlide;
  return templateMode ? COPY.confirmDeleteLayouts : COPY.confirmDeleteSlides;
}

export function deleteSlidesLabel(count: number): string {
  return count > 1 ? `${COPY.deleteSlides} (${count})` : COPY.deleteSlide;
}
